/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListSkillsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'
import {ListSkillsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/skills_messages.pb'


export const listSkills = (request: ListSkillsRequest, options?: CashRequestOptions) => post<ListSkillsRequest, ListSkillsResponse>("/2.0/cash/list-skills", request, {...options, rejectOnError: true })